import { render, staticRenderFns } from "./lawsuit_1.vue?vue&type=template&id=4bc7b6c8&scoped=true"
import script from "./lawsuit_1.vue?vue&type=script&lang=js"
export * from "./lawsuit_1.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_1.vue?vue&type=style&index=0&id=4bc7b6c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7b6c8",
  null
  
)

export default component.exports